// src/config/routes/public.routes.ts
import { BarChartBig, ChartBarBig, FunctionSquare, Hexagon, Monitor, Network, ScrollText, User } from 'lucide-react';
import { lazy } from 'react';
import { RouteConfig } from 'src/types/route-config.types';

export const protectedRoutes: RouteConfig[] = [
    {
        name: "Dashboard",
        path: "/dashboard",
        component: lazy(() => import('src/pages/dashboard/DashboardMain')),
        showInSideNav: true,
        sideNavGroupName: "",
        isDefaultFor: ["admin", 'administrator'],
        access: ["admin", "administrator"],
        breadcrumbPath: ["Dashboard"],
        icon: <ChartBarBig className='h-4 w-4' />,
        order: 2.1,
        meta: {
            title: "",
            description: ""
        }
    },
  
    {
        name: "Energy Monitoring",
        path: "/energy-monitoring",
        component: lazy(() => import('src/pages/energy-monitoring/EnergyMonitoringDashboardPage')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["admin", "administrator"],
        breadcrumbPath: ["dashboard"],
        icon: <User className='h-2 w-2' />,
        order: 3,
        meta: {
            title: "Energy Monitoring Dashboard",
            description: "Monitor energy generation and consumption with detailed analytics."
        }
    },
  // --- energy audit ---
    {
        name: "Consumer Energy Audit Details",
        path: "/energy-audit/consumer-details",
        component: lazy(() => import('src/pages/audit-report/consumer/audit-details/ConsumerAuditDetails')),
        showInSideNav: false,
        sideNavGroupName: "",
        access: ["admin", "administrator"],
        breadcrumbPath: ["dashboard"],
        icon: <User className='h-2 w-2' />,
        order: 3,
        meta: {
            title: "Consumer Energy Audit",
            description: "Monitor energy consumption with detailed analytics."
        }
    },
    {
        name: "Generator Energy Audit",
        path: "/energy-audit/generator-details",
        component: lazy(() => import('src/pages/audit-report/generator/audit-details/GeneratorAuditDetails')),
        showInSideNav: false,
        sideNavGroupName: "",
        access: ["admin", "administrator"],
        breadcrumbPath: ["dashboard"],
        icon: <User className='h-2 w-2' />,
        order: 3,
        meta: {
            title: "Generator Energy Audit ",
            description: "Monitor energy generation and consumption with detailed analytics."
        }
    },

    {
        name: "Generation Energy Audit Report",
        path: "/energy-audit/generator-report",
        component: lazy(() => import('src/pages/audit-report/generator/audit-report/GeneratorAuditReport')),
        showInSideNav: false,
        sideNavGroupName: "",
        access: ["admin"],
        breadcrumbPath: ["energy-setting", "Energy Setting Form"],
        // icon: <FunctionSquare className='h-4 w-4' />,
        order: 8.2,
        meta: {
            title: "Generator Energy Audit Report",
            description: "Generation energy audit report with detailed analytics"
        }
    },


    {
        name: "Consumer Energy Audit Report",
        path: "/energy-audit/consumer-report",
        component: lazy(() => import('src/pages/audit-report/consumer/audit-report/ConsumerAuditReport')),
        showInSideNav: false,
        sideNavGroupName: "",
        access: ["admin"],
        breadcrumbPath: ["energy-setting", "Energy Setting Form"],
        // icon: <FunctionSquare className='h-4 w-4' />,
        order: 8.2,
        meta: {
            title: "Consumer Energy Audit Report",
            description: "Consumption energy audit report with detailed analytics"
        }
    },


    // --- Onboarding Section ---



    // --- System Monitoring Section ---
    // {
    //     name: "Real-Time System Dashboard",
    //     path: "/system-monitoring/real-time-dashboard",
    //     component: lazy(() => import('src/pages/system-monitoring/dashbaord/DashboardPage')),
    //     showInSideNav: true,
    //     sideNavGroupName: "System Monitoring",
    //     access: ["admin", "administrator"],
    //     breadcrumbPath: ["System Monitoring", "Real-Time System Dashboard"],
    //     icon: <Monitor className='h-2 w-2' />,
    //     order: 3.1,
    //     meta: {
    //         title: "Real-Time Dashboard",
    //         description: "Live view of system performance, energy flow, and operational metrics."
    //     }
    // },
      {
        name: "Energy Monitoring",
        path: "/energy-monitoring",
        component: lazy(() => import('src/pages/energy-monitoring/EnergyMonitoringDashboardPage')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["admin", "administrator"],
        breadcrumbPath: ["dashboard"],
        icon: <User className='h-2 w-2' />,
        order: 3,
        meta: {
            title: "Energy Monitoring Dashboard",
            description: "Monitor energy generation and consumption with detailed analytics."
        }
    },

        {
        name: "Admin",
        path: "/onboarding/admin",
        component: lazy(() => import('src/pages/onboarding/admin/admin-report/AdminReportPage')),
        showInSideNav: true,
        sideNavGroupName: "Onboarding",
        access: ["admin", "administrator"],
        breadcrumbPath: ["Onboarding", "Admin"],
        icon: <User className='h-2 w-2' />,
        order: 2.1,
        meta: {
            title: "Onboard Admin User",
            description: "Register and configure new admin user"
        }
    },
    {
        name: "Generators",
        path: "/onboarding/generator",
        component: lazy(() => import('src/pages/onboarding/generators/generators-report/GeneratorsReportPage')),
        showInSideNav: true,
        sideNavGroupName: "Onboarding",
        access: ["admin", "administrator"],
        breadcrumbPath: ["Onboarding", "generator"],
        icon: <User className='h-2 w-2' />,
        order: 2.1,
        meta: {
            title: "Generator Onboarding",
            description: "Register and configure green energy generators."
        }
    },

    {
        name: "Generator Profile",
        path: "/onboarding/generator/profile-details/:consumer_id",
        component: lazy(() => import('src/pages/onboarding/generators/generator-profile/GeneratorProfilePage')),
        showInSideNav: false,
        sideNavGroupName: "Onboarding",
        access: ["admin", "administrator"],
        breadcrumbPath: ["Onboarding", "generator"],
        icon: <User className='h-2 w-2' />,
        order: 2.1,
        // meta: {
        //     // title: "Onboard generator",
        //     // description: "Register and configure new energy generators in the system."
        // }
    },


    {
        name: "Consumer",
        path: "/onboarding/consumer",
        component: lazy(() => import('src/pages/onboarding/consumers/consumers-report/ConsumersReportPage')),
        showInSideNav: true,
        sideNavGroupName: "Onboarding",
        access: ["admin", "administrator"],
        breadcrumbPath: ["Onboarding", "consumer"],
        icon: <User className='h-2 w-2' />,
        order: 2.1,
        meta: {
            title: "Consumer Onboarding",
            description: "Register and configure green energy consumers."
        }
    },

    {
        name: "Consumers Profile",
        path: "/onboarding/consumer/profile-details/:consumer_id",
        component: lazy(() => import('src/pages/onboarding/consumers/consumer-profile/ConsumerProfilePage')),
        showInSideNav: false,
        sideNavGroupName: "Onboarding",
        access: ["admin", "administrator"],
        breadcrumbPath: ["Onboarding", "consumer"],
        icon: <User className='h-2 w-2' />,
        order: 2.1,
        meta: {
            title: "Onboard consumer",
            description: "Energy generators details"
        }
    },

    // --- System Monitoring Section ---
    // {
    //     name: "Real-Time System Dashboard",
    //     path: "/system-monitoring/real-time-dashboard",
    //     component: lazy(() => import('src/pages/system-monitoring/dashbaord/DashboardPage')),
    //     showInSideNav: true,
    //     sideNavGroupName: "System Monitoring",
    //     access: ["admin", "administrator"],
    //     breadcrumbPath: ["System Monitoring", "Real-Time System Dashboard"],
    //     icon: <Monitor className='h-2 w-2' />,
    //     order: 3.1,
    //     meta: {
    //         title: "Real-Time Dashboard",
    //         description: "Live view of system performance, energy flow, and operational metrics."
    //     }
    // },
    // {
    //     name: "Energy Monitoring",
    //     path: "/energy-monitoring",
    //     component: lazy(() => import('src/pages/energy-monitoring/EnergyMonitoringDashboardPage')),
    //     showInSideNav: true,
    //     sideNavGroupName: "System Monitoring",
    //     access: ["admin", "administrator"],
    //     breadcrumbPath: ["dashboard"],
    //     icon: <User className='h-2 w-2' />,
    //     order: 3,
    //     meta: {
    //         title: "Energy Monitoring Dashboard",
    //         description: "Monitor energy generation and consumption with detailed analytics."
    //     }
    // },
    // {
    //     name: "Logging",
    //     path: "/system-monitoring/event-logging",
    //     component: lazy(() => import('src/pages/audit/event-logging/EventLoggingAuditTrail')),
    //     showInSideNav: true,
    //     sideNavGroupName: "System Monitoring",
    //     access: ["admin", "administrator"],
    //     breadcrumbPath: ["System Monitoring", "Logging"],
    //     icon: <User className='h-2 w-2' />,
    //     order: 2.1,
    //     meta: {
    //         title: "User Activity Logging",
    //         description: "Track and log user activities for GEC."
    //     }
    // },
    // {
    //     name: "Performance Alerts & Notifications",
    //     path: "/notification/notification-report",
    //     component: lazy(() => import('src/components/nofification/report/NotificationReport')),
    //     showInSideNav: true,
    //     sideNavGroupName: "System Monitoring",
    //     access: ["admin", "administrator"],
    //     breadcrumbPath: ["System Monitoring", "Performance Alerts & Notifications"],
    //     icon: <User className='h-2 w-2' />,
    //     order: 2.1,
    //     meta: {
    //         title: "Performance Alerts & Notifications",
    //         description: "View and manage system performance alerts and notifications."
    //     }
    // },
    // {
    //     name: "Analytics",
    //     path: "/analytics/analytics-report",
    //     component: lazy(() => import('src/components/analytics/report/AnalyticsReport')),
    //     showInSideNav: true,
    //     sideNavGroupName: "System Monitoring",
    //     access: ["admin", "administrator"],
    //     breadcrumbPath: ["System Monitoring", "Analytics"],
    //     icon: <User className='h-2 w-2' />,
    //     order: 2.1,
    //     meta: {
    //         title: "Analytics",
    //         description: "Register and configure new energy generators in the system."
    //     }
    // },
    // {
    //     name: "Logging",
    //     path: "/system-monitoring/event-logging",
    //     component: lazy(() => import('src/pages/audit/event-logging/EventLoggingAuditTrail')),
    //     showInSideNav: true,
    //     sideNavGroupName: "System Monitoring",
    //     access: ["admin", "administrator"],
    //     breadcrumbPath: ["System Monitoring", "Logging"],
    //     icon: <User className='h-2 w-2' />,
    //     order: 2.1,
    //     meta: {
    //         title: "Onboard consumer",
    //         description: "Register and configure new energy generators in the system."
    //     }
    // },
    // {
    //     name: "Performance Alerts & Notifications",
    //     path: "/notification/notification-report",
    //     component: lazy(() => import('src/components/nofification/report/NotificationReport')),
    //     showInSideNav: true,
    //     sideNavGroupName: "System Monitoring",
    //     access: ["admin", "administrator"],
    //     breadcrumbPath: ["System Monitoring", "Performance Alerts & Notifications"],
    //     icon: <User className='h-2 w-2' />,
    //     order: 2.1,
    //     meta: {
    //         title: "Performance Alerts & Notifications",
    //         description: "View and manage system performance alerts and notifications."
    //     }
    // },
    // {
    //     name: "Analytics",
    //     path: "/analytics/analytics-report",
    //     component: lazy(() => import('src/components/analytics/report/AnalyticsReport')),
    //     showInSideNav: true,
    //     sideNavGroupName: "System Monitoring",
    //     access: ["admin", "administrator"],
    //     breadcrumbPath: ["System Monitoring", "Analytics"],
    //     icon: <User className='h-2 w-2' />,
    //     order: 2.1,
    //     meta: {
    //         title: "Analytics",
    //         description: "Register and configure new energy generators in the system."
    //     }
    // },

    // --- Token Management Section ---

    // {
    //     name: "Dashboard",
    //     path: "/token-management/dashboard",
    //     component: lazy(() => import('src/pages/tokens-management/tokens-dashboard/TokensDashboardPage')),
    //     showInSideNav: true,
    //     sideNavGroupName: "Token Management",
    //     access: ["admin", "administrator"],
    //     breadcrumbPath: ["Token Management", "Dashboard"],
    //     icon: <Hexagon className='h-4 w-4' />,
    //     order: 5.1,
    //     meta: {
    //         title: "Token Dashboard",
    //         description: "Summary and status of all energy tokens in the system."
    //     }
    // },
    // {
    //     name: "Token Report",
    //     path: "/token/token-report",
    //     component: lazy(() => import('src/pages/tokens-management/tokens-dashboard-report/TokensDashboardReportPage')),
    //     showInSideNav: false,
    //     sideNavGroupName: "Token Management",
    //     access: ["admin"],
    //     breadcrumbPath: ["Token Report", "Token"],
    //     icon: <User className='h-2 w-2' />,
    //     order: 2.1,
    //     meta: {
    //         title: "Analytics",
    //         description: "Register and configure new energy generators in the system."
    //     }
    // },

    {
        name: "Token Generation Report",
        path: "/token/token-generation-report",
        component: lazy(() => import('src/pages/tokens-management/tokens-dashboard-report/TokensDashboardReportPage')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["admin", "administrator"],
        breadcrumbPath: ["Token Management", "Token Generation"],
        icon: <User className='h-2 w-2' />,
        order: 2.1,
        meta: {
            title: "Token Generation Report",
            description: "Detailed report on the generation of energy tokens."
        }
    },

    // {
    //     name: "Allocation Rules",
    //     path: "/token-management/allocation-rules",
    //     component: lazy(() => import('src/components/token/components/token-allocation/TokenAllocationReport')),
    //     showInSideNav: true,
    //     sideNavGroupName: "Token Management",
    //     access: ["admin", "administrator"],
    //     breadcrumbPath: ["Token Management", "Allocation Rules"],
    //     icon: <Hexagon className='h-4 w-4' />,
    //     order: 5.4,
    //     meta: {
    //         title: "Allocation Rules",
    //         description: "Configure Token Flow and Assignment Criteria."
    //     }
    // },


    // --- Consumption and Reconsilation Section ---

    // {
    //     name: "Consumption Analysis Report",
    //     path: "/consumption-analysis/report",
    //     component: lazy(() => import('src/pages/ConsumptionAnalysis/DashBoardPage')),
    //     showInSideNav: true,
    //     sideNavGroupName: "Consumption and Reconsilation",
    //     access: ["admin", "administrator"],
    //     breadcrumbPath: ["Consumption and Reconsilation", "Consumption Analysis Report"],
    //     icon: <Hexagon className='h-4 w-4' />,
    //     order: 5.3,
    //     meta: {
    //         title: "Consumption Analysis",
    //         description: "Provides users with real-time insights and detailed historical data."
    //     }
    // },

    // {
    //     name: "Reconciliation Triggers Report",
    //     path: "/reconciliation-triggers/report",
    //     component: lazy(() => import('src/components/reconciliation-triggers/reports/ReconciliationTriggersReport')),
    //     showInSideNav: true,
    //     sideNavGroupName: "Consumption and Reconsilation",
    //     access: ["admin"],
    //     breadcrumbPath: ["Consumption and Reconsilation", "Reconciliation Triggers Report"],
    //     icon: <Hexagon className='h-4 w-4' />,
    //     order: 5.3,
    //     meta: {
    //         title: "Reconciliation Triggers Report",
    //         description: "A Trigger Mechanisms Behind Reconciliation."
    //     }
    // },

    // {
    //     name: "Energy Loss Modeling & RPO",
    //     path: "/energy-loss/report",
    //     component: lazy(() => import('src/components/energy-loss-modeling/dashboard/energy-loss-modeling/reports/energyLossReport')),
    //     showInSideNav: true,
    //     sideNavGroupName: "Consumption and Reconsilation",
    //     access: ["admin"],
    //     breadcrumbPath: ["Consumption and Reconsilation", "Energy Loss Modeling & RPO"],
    //     icon: <Hexagon className='h-4 w-4' />,
    //     order: 5.3,
    //     meta: {
    //         title: "Energy Loss Modeling & RPO",
    //         description: "Trigger Mechanisms Behind Reconciliation"
    //     }
    // },

    // {
    //     name: "Manual Override Capability",
    //     path: "/manual-override-capability/override-capability",
    //     component: lazy(() => import('src/components/manual-override-capability/ManualOverridingCapabilityReport')),
    //     showInSideNav: true,
    //     sideNavGroupName: "Manual Override Capability",
    //     access: ["admin"],
    //     breadcrumbPath: ["Manual Override Capability", "Manual Override Capability"],
    //     icon: <Hexagon className='h-4 w-4' />,
    //     order: 5.3,
    //     meta: {
    //         title: "Token Assignment",
    //         description: "Assign generated tokens to different entities or accounts."
    //     }
    // },

    // {
    //     name: "Feeder Loss & RPO Data",
    //     path: "/feeder-loss/report",
    //     component: lazy(() => import('src/components/energy-loss-modeling/dashboard/feeder-loss/reports/FeederLoss-RPO-Report')),
    //     showInSideNav: true,
    //     sideNavGroupName: "Energy Loss Modeling & RPO Consideration",
    //     access: ["admin"],
    //     breadcrumbPath: ["Feeder Loss & RPO Data", "Feeder Loss & RPO Data"],
    //     icon: <Hexagon className='h-4 w-4' />,
    //     order: 5.3,
    //     meta: {
    //         title: "Feeder Loss & RPO Data",
    //         description: ""
    //     }
    // },


    // --- GEC Certificate Management Section ---

    {
        name: "GEC List",
        path: "/gec-management/issuance",
        component: lazy(() => import('src/pages/gec/gec-list-Issuance-report/DashboardPage')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["admin"],
        breadcrumbPath: ["GEC Certificate Management", "GEC List / Issuance"],
        icon: <ScrollText className='h-4 w-4' />,
        order: 8.1,
        meta: {
            title: "GEC List & Issuance Details",
            description: "List and issuance details of Green Energy Certificates."
        }
    },

    {
        name: "GEC Tracibility Report",
        path: "/gec-management/tracibility-report/:id",
        component: lazy(() => import('src/pages/gec/gec-tracibility-report/GRCTracibilityReportPage')),
        showInSideNav: false,
        sideNavGroupName: "GEC Certificate Management",
        access: ["admin"],
        breadcrumbPath: ["GEC Certificate Management", "GEC Tracibility"],
        icon: <ScrollText className='h-4 w-4' />,
        order: 8.1,
        meta: {
            title: "GEC List & Issuance",
            description: "To register an eligible consumer for energy usage."
        }
    },

    // {
    //     name: "RPO Compliance Tagging",
    //     path: "/gec-management/gec-rpo-compliance-tagging-report",
    //     component: lazy(() => import('src/pages/gec/gec-rpo-compliance-tagging-report/DashboardPage')),
    //     showInSideNav: true,
    //     sideNavGroupName: "GEC Certificate Management",
    //     access: ["admin"],
    //     breadcrumbPath: ["GEC Certificate Management", "RPO Compliance Tagging"],
    //     icon: <ScrollText className='h-4 w-4' />,
    //     order: 8.2,
    //     meta: {
    //         title: "RPO Compliance Tagging",
    //         description: ""
    //     }
    // },
    // {
    //     name: "Export / Audit",
    //     path: "/gec-management/export",
    //     component: lazy(() => import('src/pages/home/HomePage')),
    //     showInSideNav: true,
    //     sideNavGroupName: "GEC Certificate Management",
    //     access: ["admin"],
    //     breadcrumbPath: ["GEC Certificate Management", "Export / Audit"],
    //     icon: <FunctionSquare className='h-4 w-4' />,
    //     order: 8.2,
    //     meta: {
    //         title: "GEC Export & Audit",
    //         description: "Export certificate data for external auditing and reporting."
    //     }
    // },

    // --- Settlement Section ---

    // {
    //     name: "Settlement List",
    //     path: "/settlement/settlement-list",
    //     component: lazy(() => import('src/pages/settlement/settelments-analysis-report/DashboardPage')),
    //     showInSideNav: true,
    //     sideNavGroupName: "Settlement",
    //     access: ["admin"],
    //     breadcrumbPath: ["Settlement", "Settlement"],
    //     icon: <ScrollText className='h-4 w-4' />,
    //     order: 8.2,
    //     meta: {
    //         title: "Settlement",
    //         description: "To register an eligible consumer for energy usage."
    //     }
    // },

    // --- Reports & Dashboards Section ---

    // {
    //     name: "Reports & Dashboards",
    //     path: "/settlement/report-list",
    //     component: lazy(() => import('src/pages/settlement/settelements-energy-analysis-report/DashboardPage')),
    //     showInSideNav: true,
    //     sideNavGroupName: "Reports & Dashboards",
    //     access: ["admin"],
    //     breadcrumbPath: ["Reports & Dashboards", "Reports & Dashboards"],
    //     icon: <ScrollText className='h-4 w-4' />,
    //     order: 8.2,
    //     meta: {
    //         title: "Reports & Dashboards",
    //         description: "To register an eligible consumer for energy usage."
    //     }
    // },


    


    {
        name: "Time Block Configuration",
        path: "/configuration/configuration-form",
        component: lazy(() => import('src/pages/configuration/time-block/ConfigurationPage')),
        showInSideNav: true,
        sideNavGroupName: "Configuration",
        access: ["admin"],
        breadcrumbPath: ["Configuration", "Configuration Form"],
        icon: <FunctionSquare className='h-4 w-4' />,
        order: 8.2,
        meta: {
            title: "Time Block",
            description: ""
        }
    },

    {
        name: "Other Configuration",
        path: "/configuration/energy-setting",
        component: lazy(() => import('src/pages/configuration/energy-setting/ConfigurationPage')),
        showInSideNav: true,
        sideNavGroupName: "Configuration",
        access: ["admin"],
        breadcrumbPath: ["energy-setting", "Energy Setting Form"],
        icon: <FunctionSquare className='h-4 w-4' />,
        order: 8.2,
        meta: {
            title: "Energy Setting",
            description: ""
        }
    },

// self service
    {
        name: "Help & Support",
        path: "/self-servivce/query-requests",
        component: lazy(() => import('src/pages/self-service/query-requests//QueryRequestsPage')),
        showInSideNav: true,
        sideNavGroupName: "",
        access: ["admin"],
        breadcrumbPath: ["Self-Service", "Query Requests"],
        icon: <FunctionSquare className='h-4 w-4' />,
        order: 8.2,
        meta: {
            title: "Help & Support",
            description: "Get assistance with your green energy queries."
        }
    },


];